/**
 * Personnalisateurs contre non-personnalisateurs.
 *
 * Un tableau et non un graphique : quatre nombres à comparer deux à deux, une
 * forme graphique n'ajouterait rien et coûterait de la place.
 *
 * ⚠️ L'avertissement sur la corrélation n'est pas décoratif. Le rapport PDF
 * génère ici une phrase du type « les personnalisateurs sont plus engagés »,
 * qui se lit vite comme « pousser la personnalisation augmentera l'engagement ».
 * C'est très probablement l'inverse : on règle sa lampe quand on a déjà
 * l'intention de rester.
 */

import { formatDecimal, formatDuration, formatInteger } from '../lib/format';
import { COLORS } from '../lib/theme';
import type { CustomizerComparison } from '../types';
import { Card } from './Card';

export function CustomizerTable({ data }: { data: CustomizerComparison }) {
  const rows = [
    {
      label: 'Comptes',
      yes: formatInteger(data.customizers),
      no: formatInteger(data.nonCustomizers),
    },
    {
      label: 'Durée moyenne de session',
      yes: formatDuration(data.customizerAvgSessionSeconds),
      no: formatDuration(data.nonCustomizerAvgSessionSeconds),
    },
    {
      label: 'Actions par session',
      yes: formatDecimal(data.customizerAvgActionsPerSession),
      no: formatDecimal(data.nonCustomizerAvgActionsPerSession),
    },
  ];

  return (
    <Card
      title="Personnalisation et engagement"
      subtitle="Un « personnalisateur » a changé la luminosité ou la langue au moins une fois"
    >
      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th />
              <th className="num">Personnalisent</th>
              <th className="num">Ne personnalisent pas</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.label}>
                <td>{row.label}</td>
                <td className="num">{row.yes}</td>
                <td className="num">{row.no}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p style={{ marginTop: 12, marginBottom: 0, fontSize: 12, color: COLORS.textMuted }}>
        Corrélation, pas causalité — et probablement dans l'autre sens : on règle sa lampe
        quand on a déjà l'intention de rester.
      </p>
    </Card>
  );
}
